
import React from 'react';


import {
} from '../../api/methodPayment.api';

import {connect} from 'react-redux';
import toastr from 'toastr';
import html2pdf from 'html2pdf.js';
import LoftyDropdownComponent from '../../components/loftydropdowncomponent';
import LoftyCountDown from '../../components/loftycountdown';
import LoftyCartCarousel from '../../components/loftycartcarousel';
import LoftyThreeCarousel from '../../components/loftythreecarousel';
import LoftyCarouselPlugin from '../../components/LoftyCarouselPlugin';
import LoftyLeaftMap from '../../components/loftyLeaftMaps';
import LoftyAnimatedParticleBackground from '../../components/loftyAnimatedParticleBackground';
import LoftyGoogleLoginComponent from '../../components/loftyGoogleLoginComponent';
import { loftyHandleCountShoppingCart } from '../../util/handleCount';
import LoftyEditorJsReadOnly from '../../components/LoftyEditorJsReadOnly';
import LoftyEditorJs from '../../components/LoftyEditorJs';

import {
	addLoftyToken,
	deleteLoftytoken,
	set_lofty_global_categorias,
} from '../../actions/auth.actions';


import './nosotros.scss';


// Hamburger
function loftyInitHam() {
  try {
  // eslint-disable-next-line no-restricted-globals
    window.addEventListener('click', (event) => {
      let originPointLeft = '';
      const comp = event.target.className;
      if (comp.includes('menu__btn') || comp.includes('span_middle') || comp.includes('span_before') || comp.includes('span_after')) {
        const res = Array.from(document.getElementsByClassName('menu__box'));
        const spanData = Array.from(document.getElementsByClassName('menu__btn'));
        const closeBtn = Array.from(document.getElementsByClassName('menu__close__btn'));
        spanData.forEach((item) => {
          originPointLeft = item.style.left;
        });
        res.forEach((item) => {
          item.style.left = '0px';
        });
        spanData.forEach((item) => {
          item.style.left = '-300px';
        });
        closeBtn.forEach((item) => {
          item.style.left = '10px';
        });
      } else {
        if (comp === 'menu__box') {
          return;
        }
        if (comp === 'linkshref') {
          return;
        }
        if (comp === 'menu__item') {
          return;
        }
        const res = Array.from(document.getElementsByClassName('menu__box'));
        const spanData = Array.from(document.getElementsByClassName('menu__btn'));
        const closeBtn = Array.from(document.getElementsByClassName('menu__close__btn'));
        res.forEach((item) => {
          item.style.left = '-300px';
        });
        spanData.forEach((item) => {
          item.style.left = originPointLeft;
        });
        closeBtn.forEach((item) => {
          item.style.left = '-100%';
        });
      }
    });
  } catch (error) {
    // console.log(error);
  }
}    
    






const Pnosotros = ({
  match,
  history,
  loftytoken,
  loftyuser,
  addLoftyUserApp,
  deleteLoftytokenApp,
  addLoftyTokenApp,
  lofty_global_categorias,
	set_lofty_global_categorias_app,

}) => {





	function function_redirigircontactanos_694619618e5aed52dc8d5666() {
		history.push("/contactanos");
	}


  
  setTimeout(() => { loftyInitHam(); }, 2000);

  
  

  
  return (
    <div id="id6942dbbe599f24ea479be760" >

      <div id="icuq" className="">
      
      <div id="ibznw" className="">
      
      <div id="" className="contentwrapperanimated ">
      
      <div id="" className="container_animated ">
      
      <label id="" className="menu__btn ">
      
      <span className="span_before " id="">
        
      </span>
      
      <span className="span_middle " id="">
        
      </span>
      
      <span className="span_after " id="">
        
      </span>
      
      </label>
      
      <label id="" className="menu__close__btn ">
      
      <span className="span__close__left " id="">
        
      </span>
      
      <span className="span__close__right " id="">
        
      </span>
      
      </label>
      
      <ul id="" className="menu__box ">
        
      <li className="linkshref " id="">
        
      <a
        target=""
        className="menu__item "
        id=""
        href="/"
        type=""
      >
        <>Inicio</>
      </a>
      
      <a
        target=""
        className="menu__item "
        id=""
        href="/soluciones"
        type=""
      >
        <>Soluciones</>
      </a>
      
      </li>
      
      <li className="linkshref " id="">
        
      <a
        target=""
        className="menu__item "
        id=""
        href="/sobregrowth"
        type=""
      >
        <>Sobre Growth</>
      </a>
      
      </li>
      
      <li className="linkshref " id="">
        
      <a
        target=""
        className="menu__item "
        id=""
        href="/casosdeexito"
        type=""
      >
        <>Casos de Éxito</>
      </a>
      
      </li>
      
      <li className="linkshref " id="">
        
      </li>
      
      <li className="linkshref " id="">
        
      <a
        target=""
        className="menu__item "
        id=""
        href="/blog"
        type=""
      >
        <>Blog</>
      </a>
      
      <a
        target=""
        className="menu__item "
        id=""
        href="/contactanos"
        type=""
      >
        <>Contacto</>
      </a>
      
      </li>
      
      </ul>
      
      </div>
      
      </div>
      
        <a
          target=""
          className=""
          id="iwhxxb"
          href="/"
        >
          
      <img
        className=""
        id="ipd1e"
        src="https://assetsprojects.s3.amazonaws.com/405gznimp7daiji.jpg"
        alt="undefined"
      />
      <>
        </>
        </a>
        <>
        </>
      </div>
      
      <div id="ig5a" className="">
      
        <a
          target=""
          className=""
          id="iope"
          href="/soluciones"
        >
          
    <div id="iye9" className="">
    <>SOLUCIONES</>
    </div>
    
        </a>
        
        <a
          target=""
          className=""
          id="i848v"
          href="/sobregrowth"
        >
          
    <div id="i8s6k" className="">
    <>NOSOTROS</>
    </div>
    
        </a>
        
        <a
          target=""
          className=""
          id="irmrk"
          href="/casosdeexito"
        >
          
    <div id="ib721" className="">
    <>CASOS DE ÉXITO</>
    </div>
    
        </a>
        
        <a
          target=""
          className=""
          id="iwshj"
          href="/blog"
        >
          
    <div id="i5dsy" className="">
    <>BLOG</>
    </div>
    
        </a>
        
        <a
          target=""
          className=""
          id="ipsxb"
          href="/contactanos"
        >
          
    <div id="ii21f" className="">
    <>CONTACTO</>
    </div>
    
        </a>
        <>
        </>
      </div>
      <>
        </>
      </div>
      
      <div
        id="ir4o8g"
        className=""
        data-aos="fade-right"
        data-aos-duration="3"
      >
      
      <div id="iiro0g" className="">
      
      <div id="ixqkpd" className="">
      
      <img
        className=""
        id="iqbqbq"
        src="https://assetsprojects.s3.amazonaws.com/404pziimgpi735c.png"
        alt="undefined"
      />
      
        <a
          target=""
          className=""
          id="icy18w"
          href="#"
        >
          <>
        </>
        </a>
        
      <img
        className=""
        id="ihqt2v"
        src="https://assetsprojects.s3.amazonaws.com/404pziimgpi735c.png"
        alt="undefined"
      />
      <>
        </>
      </div>
      
      <div id="i804h5" className="">
      
      <div id="ihdso6" className="">
      
      <div className="" id="ix6ate">
        
      <span className="" id="">
        
      </span>
      
    <div id="" className="">
    
      <span className="" id="iytanp">
        <>Nosotros</>
      </span>
      
    </div>
    
      </div>
      <>
        </>
      </div>
      
      <div id="i1qvb7" className="">
      
      <div className="" id="ixgdn8">
        
      <p className="MsoNormal " id="">
        <>Somos una startup especializada en crecimiento sostenible
para empresas y marcas digitales.</>
    <div id="" className="">
    
    </div>
    
      </p>
      
      <p className="MsoNormal " id="">
        <>Unimos estrategia, datos y tecnología para escalar
resultados con precisión y eficiencia.</>
    <div id="" className="">
    
    </div>
    
      </p>
      
      </div>
      <>
        </>
      </div>
      <>
        </>
      </div>
      
      <div id="idnwup" className="">
      <>
        </>
      </div>
      <>
        </>
      </div>
      
      </div>
      
      <div
        id="i9n8ev"
        className=""
        data-aos="fade-right"
        data-aos-duration="199"
      >
      
      <div id="ivh90m" className="">
      
      <div className="" id="ivn254">
        <>Nuestros Valores</>
      </div>
      <>
        </>
      </div>
      
      <div id="i0541v" className="">
      
      <div id="i2f8uz" className="">
      
      <div className="" id="i4gcza">
        
      <p className="" id="izruei">
        <>Excelencia en la ejecución</>
    <div id="" className="">
    
    </div>
    
      </p>
      
      </div>
      
      <div className="" id="i5wfd9">
        
      <p className="MsoNormal " id="">
        
      <span className="" id="">
        <>Reconoce
hasta la existencia, reflejada en nuestros entregables y los resultados de los
proyectos que trabajamos.</>
    <div id="" className="">
    
    </div>
    
      </span>
      
      </p>
      
      </div>
      <>
        </>
      </div>
      
      <div id="iarum7" className="">
      
      <div className="" id="inwjle">
        
      <p className="" id="iwp7zy">
        <>Excelencia en la ejecución</>
    <div id="" className="">
    
    </div>
    
      </p>
      
      </div>
      
      <div className="" id="ilnpo8">
        
      <p className="MsoNormal " id="">
        
      <span className="" id="">
        <>Reconoce
hasta la existencia, reflejada en nuestros entregables y los resultados de los
proyectos que trabajamos.</>
    <div id="" className="">
    
    </div>
    
      </span>
      
      </p>
      
      </div>
      <>
        </>
      </div>
      
      <div id="irq12g" className="">
      
      <div className="" id="imcncg">
        
      <p className="" id="iyrn82">
        <>Excelencia en la ejecución</>
    <div id="" className="">
    
    </div>
    
      </p>
      
      </div>
      
      <div className="" id="i97bxw">
        
      <p className="MsoNormal " id="">
        
      <span className="" id="">
        <>Reconoce
hasta la existencia, reflejada en nuestros entregables y los resultados de los
proyectos que trabajamos.</>
    <div id="" className="">
    
    </div>
    
      </span>
      
      </p>
      
      </div>
      <>
        </>
      </div>
      
      <div id="iay9up" className="">
      
      <div className="" id="i0dkty">
        
      <p className="" id="ignxg2">
        <>Excelencia en la ejecución</>
    <div id="" className="">
    
    </div>
    
      </p>
      
      </div>
      
      <div className="" id="iakyd2">
        
      <p className="MsoNormal " id="">
        
      <span className="" id="">
        <>Reconoce
hasta la existencia, reflejada en nuestros entregables y los resultados de los
proyectos que trabajamos.</>
    <div id="" className="">
    
    </div>
    
      </span>
      
      </p>
      
      </div>
      <>
        </>
      </div>
      <>
        </>
      </div>
      
      </div>
      
      <div id="i7d4tr" className="">
      <>
        </>
      </div>
      
      <div id="i7c4v6" className="">
      
      <div id="isbxc6" className="">
      
      <div id="illtni" className="">
      
      <div
        id="ieeblv"
        className=""
        data-aos="fade-right"
        data-aos-duration="undefined"
      >
      
      <div id="ib3qo3" className="">
      
      <div id="ixtsby" className="">
      
      <div id="iqbxn5" className="">
      
      <img
        className=""
        id="irisjk"
        src="https://assetsprojects.s3.amazonaws.com/404pziimgqmbjq5.jpg"
        alt="undefined"
      />
      <>
        </>
      </div>
      
      <div id="i8uqr8" className="">
      
      <div className="" id="ibdy23">
        <>MISIÓN</>
      </div>
      <>
        </>
      </div>
      
      <div id="iv1qaq" className="">
      
      <div className="" id="i5726t">
        <>Transformar negocios tradicionales en sistemas digitales vivos, integrando tecnología, estrategia y automatización para potenciar su capacidad de vender, crecer y expandirse a nuevos mercados, construyendo una presencia digital sólida y sostenible.</>
      </div>
      <>
        </>
      </div>
      <>
        </>
      </div>
      
      <div id="ih5u4w" className="">
      
      <img
        className=""
        id="i16vpg"
        src="https://assetsprojects.s3.amazonaws.com/404pziimgqmif5g.jpg"
        alt="undefined"
      />
      <>
        </>
      </div>
      <>
        </>
      </div>
      
      </div>
      
      <div
        id="iyy5kk"
        className=""
        data-aos="fade-right"
        data-aos-duration="undefined"
      >
      
      <div id="iz45rd" className="">
      
      <div id="i769n5" className="">
      
      <div id="iqjnzs" className="">
      
      <img
        className=""
        id="i0sjvf"
        src="https://assetsprojects.s3.amazonaws.com/404pziimgqmbjq5.jpg"
        alt="undefined"
      />
      <>
        </>
      </div>
      
      <div id="ir5jie" className="">
      
      <div className="" id="ifxevm">
        <>VISIÓN</>
      </div>
      <>
        </>
      </div>
      
      <div id="ia09sy" className="">
      
      <div className="" id="iyy1o4">
        <>Ser un referente en la transformación digital de negocios en Latinoamérica, impulsando empresas que operen como sistemas inteligentes, escalables y preparados para competir en mercados globales.</>
      </div>
      <>
        </>
      </div>
      <>
        </>
      </div>
      
      <div id="in29fe" className="">
      
      <img
        className=""
        id="i2ym3p"
        src="https://assetsprojects.s3.amazonaws.com/404pziimgqmx044.jpg"
        alt="undefined"
      />
      <>
        </>
      </div>
      <>
        </>
      </div>
      
      </div>
      
      <div
        id="iamvv6"
        className=""
        data-aos="fade-right"
        data-aos-duration="undefined"
      >
      
      <div id="i0j0ih" className="">
      
      <div id="itjxxk" className="">
      
      <div id="iw6vvy" className="">
      
      <img
        className=""
        id="ir4757"
        src="https://assetsprojects.s3.amazonaws.com/404pziimgqmbjq5.jpg"
        alt="undefined"
      />
      <>
        </>
      </div>
      
      <div id="io88ni" className="">
      
      <div id="ikuph2" className="">
      
      <div className="" id="iew9pa">
        <>VALORES</>
      </div>
      <>
        </>
      </div>
      <>
        </>
      </div>
      
      <div id="igm1b2" className="">
      
      <div className="" id="ilwdrj">
        <>Simplicidad operativa</>
      <br className="" id="" />
      <>Convertimos lo complejo en sistemas claros, funcionales y fáciles de operar.</>
      </div>
      <>
        </>
      </div>
      <>
        </>
      </div>
      
      <div id="i9iv7m" className="">
      
      <img
        className=""
        id="ivh0ol"
        src="https://assetsprojects.s3.amazonaws.com/404pziimgqn4nc1.jpg"
        alt="undefined"
      />
      <>
        </>
      </div>
      <>
        </>
      </div>
      
      </div>
      <>
        </>
      </div>
      <>
        </>
      </div>
      
      <div
        id="imfmaq"
        className=""
        data-aos="fade-right"
        data-aos-duration="undefined"
      >
      
      <div id="il7h3k" className="">
      
      <div id="ima1tj" className="">
      
      <div className="" id="iht1i4">
        <>Nuestro Equipo</>
      </div>
      <>
        </>
      </div>
      
      <div id="iokmrf" className="">
      
      <div className="" id="iodq4j">
        <>Conozca al increíble equipo detrás de</>
      </div>
      
      <img
        className=""
        id="ilbrey"
        src="https://assetsprojects.s3.amazonaws.com/405gznimp7daiji.jpg"
        alt="undefined"
      />
      <>
        </>
      </div>
      
      <div id="ibelkh" className="">
      
      <div id="i7rpwv" className="">
      
      <div id="i62nms" className="">
      
      <div id="ixj73e" className="">
      
      <div id="ibl2l5" className="">
      
      <div id="iq4e0l" className="">
      
      <div className="" id="ilbq9k">
        
      <span className="" id="">
        
      </span>
      
      <b className="" id="">
        <>Sarah Gilbert</>
      </b>
      
      <br className="" id="" />
      <>CEO & Founder</>
      </div>
      <>
        </>
      </div>
      <>
        </>
      </div>
      
      <div id="iuzj04" className="">
      
      <div className="" id="ia1ubo">
        <>Especialista en front-end y arquitecturas escalables. Ha dirigido equipos de desarrollo en soluciones SaaS.</>
      </div>
      <>
        </>
      </div>
      <>
        </>
      </div>
      <>
        </>
      </div>
      
      <div id="isdl4l" className="">
      
      <div id="io0fx5" className="">
      
      <div id="i66btg" className="">
      
      <div id="ir0wwu" className="">
      
      <div className="" id="ik01iy">
        
      <span className="" id="">
        
      </span>
      
      <b className="" id="">
        <>Stephen Joe</>
      </b>
      
      <br className="" id="" />
      <>Social Media Manager</>
      </div>
      <>
        </>
      </div>
      <>
        </>
      </div>
      
      <div id="i5n7jh" className="">
      
      <div className="" id="i46104">
        <>+8 años liderando proyectos digitales para marcas de retail y salud. Experta en experiencia de usuario y análisis de métricas.</>
      </div>
      <>
        </>
      </div>
      <>
        </>
      </div>
      <>
        </>
      </div>
      <>
        </>
      </div>
      
      <div id="i60cs7" className="">
      
      <div id="imzpuv" className="">
      
      <div id="iltz0z" className="">
      
      <div id="i9s7ul" className="">
      
      <div id="igpdia" className="">
      
      <div className="" id="i88oek">
        
      <span className="" id="">
        
      </span>
      <>Amanda Johnson</>
      <b className="" id="">
        
      <br className="" id="" />
      
      </b>
      <>CEO & Founder</>
      </div>
      <>
        </>
      </div>
      <>
        </>
      </div>
      
      <div id="ikznqi" className="">
      
      <div className="" id="il6a81">
        <>Redactor y estratega de contenidos con enfoque en SEO técnico y storytelling.</>
      </div>
      <>
        </>
      </div>
      <>
        </>
      </div>
      <>
        </>
      </div>
      <>
        </>
      </div>
      <>
        </>
      </div>
      
      <div id="iaj5lx" className="">
      
      <div id="i7iaaq" className="">
      
      <div id="ix80cg" className="">
      
      <div id="inlfmq" className="">
      
      <div id="ilvcdy" className="">
      
      <div className="" id="iji03k">
        
      <span className="" id="">
        
      </span>
      
      <b className="" id="iulo0k">
        <>Sarah Gilbert</>
      </b>
      
      <br className="" id="" />
      <>CEO & Founder</>
      </div>
      <>
        </>
      </div>
      <>
        </>
      </div>
      
      <div id="i0vivi" className="">
      
      <div className="" id="i21zym">
        <>Especialista en front-end y arquitecturas escalables. Ha dirigido equipos de desarrollo en soluciones SaaS.</>
      </div>
      <>
        </>
      </div>
      <>
        </>
      </div>
      
      <div id="iuasla" className="">
      
      <div id="ifhbux" className="">
      
      <div id="icfurk" className="">
      
      <div className="" id="isgyhg">
        
      <span className="" id="">
        
      </span>
      
      <b className="" id="is4w2i">
        <>Stephen Joe</>
      </b>
      
      <br className="" id="" />
      <>Social Media Manager</>
      </div>
      <>
        </>
      </div>
      <>
        </>
      </div>
      
      <div id="if5usn" className="">
      
      <div className="" id="ifajwi">
        <>+8 años liderando proyectos digitales para marcas de retail y salud. Experta en experiencia de usuario y análisis de métricas.</>
      </div>
      <>
        </>
      </div>
      <>
        </>
      </div>
      <>
        </>
      </div>
      
      <div id="ikg0dh" className="">
      
      <div id="ilq5jh" className="">
      
      <div id="i34pa8" className="">
      
      <div id="io0m5c" className="">
      
      <div className="" id="i603wb">
        
      <span className="" id="">
        
      </span>
      
      <b className="" id="">
        <>Amanda Johnson</>
      </b>
      
      <br className="" id="" />
      <>Senior Content Writer</>
      </div>
      <>
        </>
      </div>
      <>
        </>
      </div>
      
      <div id="igr8sl" className="">
      
      <div className="" id="ijz27j">
        <>Redactor y estratega de contenidos con enfoque en SEO técnico y storytelling.</>
      </div>
      <>
        </>
      </div>
      <>
        </>
      </div>
      <>
        </>
      </div>
      <>
        </>
      </div>
      <>
        </>
      </div>
      
      </div>
      
      <div id="i6j7uq" className="">
      <>
        </>
      </div>
      <>
        </>
      </div>
      
      <div id="isqkaw" className="">
      
      <div id="inwpbh" className="">
      
      <div id="iblzwv" className="">
      
      <img
        className=""
        id="i2yoxn"
        src="https://assetsprojects.s3.amazonaws.com/404pziimgpsbgsp.png"
        alt="undefined"
      />
      <>
        </>
      </div>
      
      <div id="imbbrp" className="">
      
      <div className="" id="i6egud">
        <>¿Listo para crecer con claridad?</>
      </div>
      <>
        </>
      </div>
      <>
        </>
      </div>
      
      <div id="iynesv" className="">
      
      <div id="ibuain" className="">
      
      <button
        type=""
        name=""
        id=""
        className="standard_button2 "
        
      >
      
      <div id="i4o7pt" className="">
      
      <span className="" id="i1ckiy">
        <>Escríbenos por WhatsApp</>
      </span>
      
      </div>
      
      </button>
      
      <button
        type=""
        name=""
        id="iby52g"
        className=""
        
      >
      
      </button>
      <>
        </>
      </div>
      
      <div id="ilk8u9" className="">
      
      <button
        type=""
        name=""
        id=""
        className="standard_button "
        onClick={async () => {
		function_redirigircontactanos_694619618e5aed52dc8d5666();
}}

      >
      
      <div id="ih6ehn" className="">
      <>Agenda una cita</>
      </div>
      
      </button>
      <>
        </>
      </div>
      <>
        </>
      </div>
      <>
        </>
      </div>
      
      <div id="ianbdo" className="">
      
      <div id="iwdt9e" className="">
      
      <img
        className=""
        id="ii474h"
        src="https://assetsprojects.s3.amazonaws.com/405gznimp7daiji.jpg"
        alt="undefined"
      />
      <>
        </>
      </div>
      
      <div id="iq1bv9" className="">
      
      <div id="i12ub7" className="">
      
      <div className="" id="i2jmyu">
        <>Tegucigalpa, Honduras</>
      </div>
      <>
        </>
      </div>
      
      <div id="ighubs" className="">
      
      <div className="" id="imu30v">
        <>+504 8740-5208</>
      </div>
      <>
        </>
      </div>
      
      <div id="i1j3uj" className="">
      
      <div className="" id="if5glq">
        <>info@origamih.com</>
      </div>
      <>
        </>
      </div>
      <>
        </>
      </div>
      
      <div id="iuromc" className="">
      
        <a
          target=""
          className=""
          id="ixhcdw"
          href="/"
        >
          
      <div className="" id="iwm1ng">
        <>Inicio</>
      </div>
      <>
        </>
        </a>
        
        <a
          target=""
          className=""
          id="ixqgrq"
          href="/soluciones"
        >
          
      <div className="" id="i1wrhc">
        <>Soluciones</>
      </div>
      <>
        </>
        </a>
        
        <a
          target=""
          className=""
          id="iitwz3"
          href="/sobregrowth"
        >
          
      <div className="" id="ia1s9u">
        <>Sobre Origamih</>
      </div>
      <>
        </>
        </a>
        
        <a
          target=""
          className=""
          id="isffwg"
          href="/casosdeexito"
        >
          
      <div className="" id="iy5ryt">
        <>Casos de Éxito</>
      </div>
      <>
        </>
        </a>
        
        <a
          target=""
          className=""
          id="iqvinb"
          href="/blog"
        >
          
      <div className="" id="ioy668">
        <>Blog</>
      </div>
      <>
        </>
        </a>
        
        <a
          target=""
          className=""
          id="i4419n"
          href="/contactanos"
        >
          
      <div className="" id="igpixs">
        <>Contacto</>
      </div>
      <>
        </>
        </a>
        <>
        </>
      </div>
      
      <div id="i0ctbp" className="">
      <>
        </>
      </div>
      <>
        </>
      </div>
      
      <div id="indubl" className="">
      
      <div id="i21uc2" className="">
      <>
        </>
      </div>
      
      <div id="inwhc2" className="">
      
      <div id="ig0f9m" className="">
      
      <img
        className=""
        id="i8uhy6"
        src="https://assetsprojects.s3.amazonaws.com/404pziimgpus7um.png"
        alt="undefined"
      />
      
      <img
        className=""
        id="ippo57"
        src="https://assetsprojects.s3.amazonaws.com/404pziimjam6dd7.png"
        alt="undefined"
      />
      <>
        </>
      </div>
      
      <div id="iwkvyf" className="">
      
      <div className="" id="ig7fxf">
        <>© 2025 Growth Holístico. Todos los derechos reservados</>
      </div>
      <>
        </>
      </div>
      <>
        </>
      </div>
      <>
        </>
      </div>
      
        <a
          target=""
          className=""
          id="izsbmk"
          href="https://wa.me/50487475208"
        >
          
      <img
        className=""
        id="i3ezwi"
        src="https://assetsprojects.s3.amazonaws.com/405gznimll0fka3.png"
        alt="undefined"
      />
      <>
        </>
        </a>
        
</div>
  );
}

const mapStateToProps = (state) => state.auth;

const mapDispatchToProps = (dispatch) => ({
 addLoftyTokenApp: (data) => dispatch(addLoftyToken(data)),
 deleteLoftytokenApp: () => dispatch(deleteLoftytoken()),
	set_lofty_global_categorias_app: (value) => dispatch(set_lofty_global_categorias(value)),
});


export default connect(mapStateToProps, mapDispatchToProps)(Pnosotros);
  